import React, { useState, useEffect } from "react";
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Container,
  Avatar,
  Button,
  Tooltip,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import logo from "../../assets/image/getmentor.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext"
import LoginModal from "../../auth/login";
import RegisterModal from "../../auth/registration";
import AddPrice from "../addpricedialog";
import ForgotPasswordDialog from "../../auth/forgetpassword";
import { encryptId } from "../../utils/encryption";

const pages = [
  { name: "Home", path: "/home" },
  { name: "Meet Our Mentor", path: "/mentors" },
  { name: "About Us", path: "/about" },
  { name: "Contact Us", path: "/query" },
];

function ResponsiveAppBar() {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [loginModalOpen, setLoginModalOpen] = React.useState(false);
  const [registerModalOpen, setRegisterModalOpen] = React.useState(false);
  const [selectedMentorPriceId, setSelectedMentorPriceId] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [openforgetDialog, setOpenforgetDialog] = useState(false);
  const { isAuthenticated, user, logout, login, authdetails } = useAuth();
  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);
  const handleOpenUserMenu = (event) => setAnchorElUser(event.currentTarget);
  const handleCloseUserMenu = () => setAnchorElUser(null);
  const [authid, setauthid] = useState("");


  const handleMenuClick = (path) => {
    navigate(path);
    handleCloseUserMenu();
  };

  // const handleprice = () => { 
  // if (authdetails?.id) {
  //     const secretKey = process.env.REACT_APP_SECRET_KEY;
  //     const encryptedId = encryptId (authdetails.mentor_id, secretKey);
  //      navigate(`/mentor/price/${encryptedId}`);
  //   }
  // };

  const handletimeslot = () => {
    if (authdetails?.id) {
      const secretKey = process.env.REACT_APP_SECRET_KEY;
      const encryptedId = encryptId(authdetails.mentor_id, secretKey);
      navigate(`/mentor/timeslot/${encryptedId}`);
    }
  };
  const handleStudent = () => {
    if (authdetails?.id) {
      const secretKey = process.env.REACT_APP_SECRET_KEY;
      const encryptedId = encryptId(authdetails.mentor_id, secretKey);
      navigate(`/mentorlist/studentlist/${encryptedId}`);
    }
  };
  const handleStudentPofile = () => {
    if (authdetails?.id) {
      // const secretKey = process.env.REACT_APP_SECRET_KEY;
      // const encryptedId = encryptId (authdetails.mentor_id, secretKey);
      navigate(`/profile`);
    }
  };
  useEffect(() => {
    if (authdetails?.id) {
      // Do something with the new ID
      setauthid(authdetails.id)
    }
  }, [authdetails]);

  const userMenuItems = () => {
    if (!isAuthenticated) {
      return [
        <MenuItem
          key="login"
          onClick={() => {
            navigate("/login")
          }}
        >
          Login
        </MenuItem>,
        <MenuItem
          key="register"
          onClick={() => {
            navigate("/registration")
          }}
        >
          Register
        </MenuItem>,
        <MenuItem
          key="forgetpassword"
          onClick={() => {
            navigate("/forget-password")
          }}
        >
          Forget Password
        </MenuItem>,
      ];
    }
    const baseItems = [
      // <MenuItem key="profile" onClick={() => handleMenuClick("/profile")}>
      //   Profile
      // </MenuItem>,
    ];
    const roleItems = {
      admin: [
        <MenuItem key="add-mentor" onClick={() => handleMenuClick("/mentorlist")}>
          Mentors
        </MenuItem>,
        // <MenuItem key="students" onClick={() => handleMenuClick("/students")}>
        //   Students
        // </MenuItem>,
        // <MenuItem key="requests" onClick={() => Price(authdetails?.id)}>
        //   Price
        // </MenuItem>,
      ],
      Mentor: [
        <MenuItem key="students" onClick={() => handleStudent()}>
          Students
        </MenuItem>,
        // <MenuItem key="requests" onClick={() => handleprice()}>
        //   Price
        // </MenuItem>,
        <MenuItem key="requests" onClick={() => handletimeslot()}>
          Time Slot
        </MenuItem>,
        <MenuItem key="Mentor" onClick={() => handleStudentPofile()}>
        Profile
      </MenuItem>

      ],
      student: [<MenuItem key="students" onClick={() => handleStudentPofile()}>
        Profile
      </MenuItem>],
    };
    const Price = (id) => {

      setSelectedMentorPriceId(id)
      setOpenDialog(true)
    }
    const logoutItem = (
      <MenuItem key="logout" onClick={() => {
        logout();
        setauthid(null);
        handleCloseUserMenu();
        navigate("/home");
      }}>
        Logout
      </MenuItem>
    );
    return [...baseItems, ...(roleItems[user] || []), logoutItem];
  };
  const refreshMentorSlots = () => {
    setSelectedMentorPriceId(null)
  };
  // console.log("authdetails", authdetails);

  return (
    <>
      <AppBar position="fixed" sx={{ background: "#2B4F60", zIndex: 1100 }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters sx={{ display: "flex", justifyContent: "space-between", height: "100%" }}>
            <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => navigate("/home")}>
              <img src={logo} alt="Logo" style={{ height: "100px", width: " " }} />
            </Box>
            <Box sx={{ flexGrow: 1, display: { xs: "none", sm: "flex" }, justifyContent: "center" }}>
              {pages.map((page) => (
                <Button
                  key={page.name}
                  sx={{
                    mx: 2,
                    color: "white",
                    fontWeight: "500",
                    fontFamily: "Poppins, sans-serif",
                    textTransform: "none",
                    transition: "0.3s ease-in-out",
                    borderBottom: location.pathname === page.path ? "3px solid #23a8e1" : "none",
                    "&:hover": {
                      color: "#23a8e1",
                      borderRadius: "8px",
                      transform: "scale(1.05)",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                    },
                  }}
                  onClick={() => navigate(page.path)}
                >
                  {page.name}
                </Button>
              ))}
            </Box>
            <Box sx={{ flexGrow: 0, display: { xs: "none", sm: "flex" } }}>
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar
                    alt="User"
                    src={authdetails ? "" : "/static/images/avatar/2.jpg"}
                    sx={{ backgroundColor: "rgb(35, 168, 225)" }}
                  >
                    {authdetails ? authdetails?.name?.charAt(0).toUpperCase() : ""}
                  </Avatar>
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: "45px" }}
                anchorEl={anchorElUser}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
                PaperProps={{
                  sx: {
                    background: "linear-gradient(to right, #0f9ba1, #8ee3a8)", // Replace with your desired color
                    color: "#fff",              // Optional: change text color to white
                    borderRadius: 2,            // Optional: rounded corners
                    boxShadow: 3                // Optional: subtle shadow
                  }
                }}
              >
                {userMenuItems()}
              </Menu>
            </Box>
            <Box sx={{ display: { xs: "flex", sm: "none" } }}>
              <IconButton color="inherit" onClick={handleDrawerToggle}>
                <MenuIcon />
              </IconButton>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Box sx={{ paddingTop: { xs: "50px", sm: "80px", md: "90px" } }} />
      <Drawer anchor="right" open={mobileOpen} onClose={handleDrawerToggle} PaperProps={{
        sx: {
          width: 250,
          background: "linear-gradient(135deg, #e0f7fa, #80deea)",
        },
      }} >
        <Box sx={{ width: 250, mt: "15px" }} role="presentation" onClick={handleDrawerToggle}>
          <List>
            {pages.map((page) => (
              <ListItem key={page.name} disablePadding>
                <ListItemButton onClick={() => navigate(page.path)}>
                  <ListItemText primary={page.name} />
                </ListItemButton>
              </ListItem>
            ))}

            <Box sx={{ my: 1 }} />

            {!isAuthenticated ? (
              <>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      navigate("/login")
                    }}
                  >
                    <ListItemText primary="Login" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      navigate("/registration")
                    }}
                  >
                    <ListItemText primary="Register" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setOpenforgetDialog(true);
                      handleDrawerToggle();
                    }}
                  >
                    <ListItemText primary="Forgot Password" />
                  </ListItemButton>
                </ListItem>
              </>
            ) : (
              <>
                {user === "Mentor" && (
                  <>
                    <ListItem disablePadding>
                      <ListItemButton
                        onClick={() => {
                          handleStudent();
                          handleDrawerToggle();
                        }}
                      >
                        <ListItemText primary="Students" />
                      </ListItemButton>
                    </ListItem>
                    {/* <ListItem disablePadding>
                      <ListItemButton
                        onClick={() => {
                          handleprice();
                          handleDrawerToggle();
                        }}
                      >
                        <ListItemText primary="Price" />
                      </ListItemButton>
                    </ListItem> */}
                    <ListItem disablePadding>
                      <ListItemButton
                        onClick={() => {
                          handletimeslot();
                          handleDrawerToggle();
                        }}
                      >
                        <ListItemText primary="Price" />
                      </ListItemButton>
                    </ListItem>
                  </>
                )}
                {user === "admin" && (
                  <>
                    <ListItem disablePadding>
                      <ListItemButton
                        onClick={() => {
                          handleMenuClick("/mentorlist");
                          handleDrawerToggle();
                        }}
                      >
                        <ListItemText primary="Mentors" />
                      </ListItemButton>
                    </ListItem>
                    {/* <ListItem disablePadding>
                      <ListItemButton
                        onClick={() => {
                          setSelectedMentorPriceId(authdetails?.id);
                          setOpenDialog(true);
                          handleDrawerToggle();
                        }}
                      >
                        <ListItemText primary="Price" />
                      </ListItemButton>
                    </ListItem> */}
                  </>
                )}
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      logout();
                      setauthid(null);
                      handleDrawerToggle();
                      navigate("/home");
                    }}
                  >
                    <ListItemText primary="Logout" />
                  </ListItemButton>
                </ListItem>
              </>
            )}
          </List>

        </Box>
      </Drawer>
      <LoginModal open={loginModalOpen} onClose={() => setLoginModalOpen(false)} onLoginSuccess={(success, userId) => {
        if (success) {
          console.log("Login successful, User ID:", userId);

          window.location.reload();
        } else {
          console.log("Login failed");
        }

      }} />
      <RegisterModal open={registerModalOpen} onClose={() => setRegisterModalOpen(false)} />
      <AddPrice
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onSubmit={refreshMentorSlots}
        selectedMentorPriceId={selectedMentorPriceId}
      />
      <ForgotPasswordDialog open={openforgetDialog} onClose={() => setOpenforgetDialog(false)} />
    </>
  );
}

export default ResponsiveAppBar;
